/** Return only a local application path, never an external/protocol-relative URL. */
export const safeReturnTo = (value: unknown): string => {
  if (typeof value !== 'string' || !value.startsWith('/') || value.startsWith('//')) return '/';
  const unsafe = (part: string) => part.startsWith('//') || part.includes('\\')
    || Array.from(part).some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127);
  if (unsafe(value)) return '/';
  try {
    // Libraries may decode path escapes. Reject nested encoded host/backslash tricks
    // without interpreting normal query/filter escapes as redirect instructions.
    let path = value.split(/[?#]/, 1)[0];
    for (let depth = 0; depth < 5; depth++) {
      if (unsafe(path)) return '/';
      const decoded = decodeURIComponent(path);
      if (decoded === path) break;
      path = decoded;
      if (depth === 4) return '/';
    }
    if (unsafe(path)) return '/';
    const base = 'https://gcm-return.invalid';
    const target = new URL(value, base);
    if (target.origin !== base) return '/';
    return target.pathname + target.search + target.hash;
  } catch {
    return '/';
  }
};
